import { BlueButton, WhiteButton, YellowButton } from "../../Button/button";
import classes from "./popup.module.css";
import Edit from "../../../../assets/images/Onboarding/edit.svg";
import { useEffect, useRef, useState } from "react";
import { companySize, companyType } from "../../../../constants";
import { errorHandler } from "../../../../utils";
import { companyInfoType } from "../../../../services/clientCalls";
import Loop2 from "../../../../assets/loader/loop2.svg";
import CreatableSelect from "react-select/creatable";
import { tagsSelectStyle } from "../../../../utils/functions";

const Popup2 = ({ data, setData, getCompanyProfile, type }) => {
  const [form, setForm] = useState(false);
  const [load, setLoad] = useState(false);
  const [industry, setIndustry] = useState([]);
  const selectRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [info, setInfo] = useState({
    companyType: "",
    companySize: "",
    industry: [],
  });
  useEffect(() => {
    if (data) {
      setInfo({
        companyType: data.companyType,
        companySize: data.companySize,
        industry: data.industry,
      });
      setIndustry(data.industry);
    }
  }, [data]);

  useEffect(() => {
    setInfo((prevState) => ({
      ...prevState,
      industry: industry,
    }));
  }, [industry]);

  const handleChange = (e) => {
    setInfo((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoad(true);
      const res = await companyInfoType(info);
      setData(res.data);
      getCompanyProfile();
      setForm(false);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      setForm(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error"
          );
    }
  };

	const addTag = (tag) => {
		if (!tag) return;
		setIndustry([...industry, tag]);
		setInputValue(""); // clear input
	};
	const handleKeyDown = (event) => {
		if (event.key === "Enter" || event.key === ",") {
		  event.preventDefault();
		  addTag(inputValue.trim());
		}
	  };

	  const handleTagChange = (newValue) => {
		setIndustry(newValue ? newValue.map(opt => opt.value) : []);
	};
  return (
    <div className={classes.main}>
      <h4>Category</h4>
      <hr />
      <p className={`${classes.spacing} ${form ? classes.dark : classes.grey}`}>
        Company Type
      </p>
      {form && (
        <select
          className="input"
          defaultValue={info.companyType}
          name="companyType"
          onChange={(e) => handleChange(e)}
        >
          <option value="Choose company type" disabled>
            Choose company type
          </option>
          {companyType.map((item) => (
            <option value={item.text}>{item.text}</option>
          ))}
        </select>
      )}
      {!form && <p className={classes.data}>{info.companyType}</p>}
      <p className={`${classes.spacing} ${form ? classes.dark : classes.grey}`}>
        Industry
      </p>
      {form && (
				<CreatableSelect
          isMulti
          ref={selectRef}
          styles={tagsSelectStyle}
          placeholder="Add an industry"
          value={industry.map((i) => ({ value: i, label: i }))}
          onChange={handleTagChange}
          isClearable={false}
          inputValue={inputValue}
              onInputChange={(value) => setInputValue(value)}
          formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
          noOptionsMessage={() => "Type and press enter to add"}
          onKeyDown={handleKeyDown}
      />
      )}

      {!form && <p className={classes.data}>{info?.industry?.join(", ")}</p>}
      <p className={`${classes.spacing} ${form ? classes.dark : classes.grey}`}>
        Company Size
      </p>
      {form && (
        <select
          onChange={(e) => handleChange(e)}
          name="companySize"
          className="input"
          value={info.companySize}
          defaultValue={info.companySize}
        >
          <option value="Choose company size" disabled>
            Choose company size
          </option>
          {companySize.map((item) => (
            <option value={item.number}>{item.employees}</option>
          ))}
        </select>
      )}
      {!form && (
        <p className={classes.data}>
          {companySize.map((item) =>
            item.number === info.companySize ? item.employees : ""
          )}
        </p>
      )}
      {type === "client" && <hr />}
      {!form && type === "client" && (
        <YellowButton
          extra={`flex ${classes.yellowBtn}`}
          onClick={() => setForm(true)}
        >
          <img src={Edit} alt="Edit" /> Edit
        </YellowButton>
      )}
      {form && (
        <div className={`flex ${classes.btn}`}>
          {load ? (
            <img src={Loop2} alt="loader" type="loader" />
          ) : (
            <>
              <WhiteButton onClick={() => setForm(false)}>Cancel</WhiteButton>
              <BlueButton onClick={handleSubmit}>Save</BlueButton>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Popup2;
